import { createFileRoute } from '@tanstack/react-router';

import { AttendanceStructureDetailLayoutContent } from './-components/AttendanceStructureDetailLayoutContent';

export const Route = createFileRoute(
  '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout',
)({
  component: AttendanceStructureDetailLayoutContent,
});
